import React, { Component } from "react";
import Events from "../../services/events.service";
import Storage from "../../services/storage.service";
import Translations from "../../services/translation";

export default class Error extends Component {
  setErrorAction = (error_button) => {
    Storage.set(error_button, true);
  };
  componentDidMount(){
    Events.when_user_clicks_on_error_pop_up_cta(
      this.props.error.text,
      this.props.error.key,
      this.props.error.code,
      this.props.error.text,
    );
  }
  getButton = (
    key,
    style = "vmo-button vmo-button-round vmo-button-wide vmo-button-red",
    cta_index
  ) => {
    let strings = Translations["keys"][Translations.activeLang];
    const { button_text } = this.props.error;

    let text =
      strings["ERROR_BUTTON_" + key.toUpperCase()] ||
      button_text ||
      strings["ERROR_BUTTON_OK_CLEAR_ERROR"];
      
      if (button_text && this.props.error?.ctas?.length === 1){
        text = button_text
      }

      if (this.props.error?.button2_text && parseInt(cta_index) === 1){
        text = this.props.error.button2_text;
      }

    return (
      <button
        key={key}
        className={style}
        onClick={() => {
          this.setErrorAction(key);
        }}
      >
        {text}
      </button>
    );
  };

  render() {
    let error_ctas = [
      "retry_payment",
      "continue_payment",
      "change_card",
      "start_chat",
      "ok_clear_error",
      "ok_clear_error_redirect",
      "ok_clear_error_get_status",
      "reset_mnp",
      "reset_flow",
      "max_sims_redirect",
      "redirect_to_app_chat",
      "redirect_to_id_check",
      "redirect_to_activation_method"
    ];

    let buttons = [];

    let ctas = [];

    if (this.props.error.ctas) {
      ctas = this.props.error.ctas;
    }
    let in_modal = true;
    if (this.props.disable_modal) {
      in_modal = false;
    }

    if (ctas.length === 0 && this.props.error.key !== "error_fatal") {
      ctas = ["ok_clear_error_redirect"];
    }

    for (let cta_index in ctas) {
      let cta = ctas[cta_index];
      let style = "vmo-button vmo-button-round vmo-button-wide vmo-button-red";
      if (cta_index > 0) {
        style = "vmo-button vmo-button-round vmo-button-wide vmo-button-white";
      }
      if (error_ctas.indexOf(cta) !== -1) {
        buttons.push(this.getButton(cta, style, cta_index));
      }
    }

    if (in_modal) {
      return (
        <div className="vmo-modal">
          <div className="vmo-modal-centered-small">
            <div className="vmo-modal-inner">
              <div className="vmo-modal-message vmo-with-icon">
                <h2>{this.props.error.title}</h2>
                {this.props.error.code ? (
                  <>
                    <p>Code: {this.props.error.code}</p>
                    <br />
                  </>
                ) : (
                  ""
                )}
                <p>{this.props.error.text}</p>
              </div>
              <div className="vmo-modal-actions">{buttons}</div>
            </div>
          </div>
        </div>
      );
    } else {
      return (
        <>
          <div className="vmo-modal-message vmo-with-icon">
            <h2>{this.props.error.title}</h2>
            {this.props.error.code ? (
              <>
                <p>Code: {this.props.error.code}</p>
                <br />
              </>
            ) : (
              ""
            )}
            <p>{this.props.error.text}</p>
          </div>
          <div className="vmo-modal-actions">{buttons}</div>
        </>
      );
    }
  }
}
